import { PropTypes } from 'react';
import { PopupSandbox } from 'react-redux-popup';
import SVGSprite from 'noc/components/svgsprite';

const App = props => (
    <div>
        <SVGSprite />
        {props.children}
        <PopupSandbox
            modalTransitionEnterTimeout={400}
            modalTransitionLeaveTimeout={400}
            popupTransitionEnterTimeout={200}
            popupTransitionLeaveTimeout={200}
        />
    </div>
);

App.propTypes = {
    children: PropTypes.node.isRequired
};

export default App;




// WEBPACK FOOTER //
// ./app/app.jsx